import { getUserInfo } from '@/services/modules/user';
import { fetchUserRoleByCK } from '@/services/modules/homepage';
import { fetchAuditStatus } from '@/services/common';
import javascriptBridge from '@/core/lib/javascript-bridge';
import { jumpToLogin } from '@/utils/helpers/ssoPlus';
import Vue from 'vue';

const SET_CURRENT_USER = 'SET_CURRENT_USER';
const SET_ROLE_ID = 'SET_ROLE_ID';
const SET_REGISTER_ROLE_ID = 'SET_REGISTER_ROLE_ID';
const SET_AUDIT_STATUS = 'SET_AUDIT_STATUS';

// 获取渠道名
function getChannelName() {
  if (javascriptBridge.device.swjApp) {
    const reg = /SwjApp\(Designer\/(.*)\)$/;
    const tempArr = reg.exec(navigator.userAgent)[1].split('/');
    return tempArr.length >= 2 ? tempArr[1] : undefined;
  }
  return undefined;
}

const state = {
  currentUser: undefined,
  roleId: undefined,
  registerRoleId: false,
  auditStatus: undefined,
};

const mutations = {
  [SET_CURRENT_USER](state, currentUser) {
    state.currentUser = currentUser;
  },
  [SET_ROLE_ID](state, roleId) {
    state.roleId = roleId;
  },
  [SET_REGISTER_ROLE_ID](state, payload) {
    state.registerRoleId = payload;
  },
  [SET_AUDIT_STATUS](state, auditStatus) {
    state.auditStatus = auditStatus;
  },
};
const actions = {
  getCurrentUser({ commit }) {
    const result = getUserInfo().then((res) => {
      if (res) {
        commit(SET_CURRENT_USER, res);
      } else {
        jumpToLogin();
      }
      return res;
    }).catch((err) => {
      console.log('[ err ]', err);
    });
    return result;
  },
  getRoleId({ commit }, payload = {}) {
    const result = fetchUserRoleByCK(payload).then((roleId) => {
      if (!state.registerRoleId) {
        // 神策埋点公共属性current_role
        // 在app外登录后需要设置current_role,在app内则由原生设置
        Vue.prototype.$sensors.registerPage({
          current_role: roleId,
        });
        commit(SET_REGISTER_ROLE_ID, true);
      }

      commit(SET_ROLE_ID, roleId);
      return roleId;
    }).catch((err) => {
      console.log('[ err ]', err);
    });
    return result;
  },
  getAuditStatus({ commit, state }) {
    const { android, swjAppVersion } = javascriptBridge.device;
    const isGetAuditStatus = android && typeof state.auditStatus === 'undefined';
    if (isGetAuditStatus && swjAppVersion) {
      const params = {
        systemType: 0, // 系统类型，0-Android，1-IOS
        versionCode: `V${swjAppVersion}`,
      };
      const channelName = getChannelName();
      if (channelName) {
        params.channelName = channelName;
      }

      fetchAuditStatus(params).then((res) => {
        if (res) {
          const { auditStatus } = res;
          commit(SET_AUDIT_STATUS, auditStatus);
        }
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
